module.exports = __webpack_public_path__ + "static/media/oly-large-catalog-img.37fd315c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Olympic/oly-large-catalog-img.jpg
// module id = 658
// module chunks = 0